// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Alert, Base } from '@gandi/ui';
import { List } from '@gandi/ui/deprecated';

import type { ExtendedResult } from '../types';

import BulkAddToCart from './BulkAddToCart';
import DomainRow from './DomainRow';

const getItemId = (item: ExtendedResult) => item.fqdn;

export type DomainListProps = {
  translator: TranslatorProps,
  allResults: Array<ExtendedResult>,
  taxesIncluded: boolean,
  ...
};

class DomainList extends React.PureComponent<DomainListProps> {
  renderDomainRow: (domain: ExtendedResult) => React.Node = (
    domain: ExtendedResult,
  ) => <DomainRow domain={domain} taxesIncluded={this.props.taxesIncluded} />;

  render(): React.Node {
    const { translator, allResults } = this.props;
    const { __ } = translator;
    const hasResults = allResults.length > 0;
    const showBulk =
      allResults.filter(result => result.renewable || result.restorable)
        .length > 1;

    return (
      <Base marginBottom="base">
        {hasResults && (
          <>
            <List variant="compact" items={allResults} itemId={getItemId}>
              {this.renderDomainRow}
            </List>
            {showBulk && <BulkAddToCart translator={translator} />}
          </>
        )}

        {!hasResults && (
          <Alert
            message={__('No results found for your search.')}
            intent="info"
          />
        )}
      </Base>
    );
  }
}

export default DomainList;
